import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { trendsMobileService } from "../../../../../../../services/mobileAPI/trends.endpoints";
import {
  setLoadingTrendsMobData,
  setTrendsMobileData,
} from "../../../../../../../features/trendsSlice";
import { setDisplayErrorSnackBar } from "../../../../../../../features/userSlice";

interface UseTrendsMobileProps {
  params?: any;
  autoFetch?: boolean;
}

export const useTrendsMobile = ({
  params,
  autoFetch = true,
}: UseTrendsMobileProps) => {
  const dispatch = useDispatch();
  const fetchTrends = useCallback(
    async (overrideParams?: any) => {
      dispatch(setLoadingTrendsMobData(true));
      try {
        const response = await trendsMobileService.getTrendsData(
          overrideParams || params,
        );
        if (!response?.status || response.status !== 200) {
          throw new Error("API failed");
        }
        dispatch(setTrendsMobileData(response.data?.data || []));
      } catch (e: any) {
        dispatch(
          setDisplayErrorSnackBar({
            message:
              e?.parsedText ||
              "Failed to fetch Trends data. Please try again later.",
            type: "error",
          }),
        );
      } finally {
        dispatch(setLoadingTrendsMobData(false));
      }
    },
    [params, dispatch],
  );
  useEffect(() => {
    if (autoFetch && params) {
      fetchTrends();
    }
    // eslint-disable-next-line
  }, [params, autoFetch, fetchTrends]);
  return {
    fetchTrends,
  };
};
